import { Loading } from '@/components/loading/Loading';

import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSignIn } from '../../services/authentication/hooks/auth';
import { PageTitle } from '../../utils/Title';

export const SignIn: FC = () => {
  const signIn = useSignIn();
  const location = useLocation();
  useEffect(() => {
    const from: string | undefined = location.state?.from;
    void signIn(from);
  }, [signIn, location]);

  return (
    <>
      <PageTitle>Sign in</PageTitle>
      <Loading className="h-screen" />
    </>
  );
};
